module.exports = __webpack_public_path__ + "static/media/achievement.f0b16c0c.jpg";